import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-10 sm:py-14 bg-navy-light/50 relative border-y border-white/5" data-id="element-191">
      <div className="mx-auto max-w-4xl px-6 lg:px-8" data-id="element-192">
        <FadeIn data-id="element-193">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-194">
            <AlertCircleIcon className="h-8 w-8 text-gold" data-id="element-195" />
            <h2 className="text-3xl sm:text-4xl font-bold text-center" data-id="element-196">
              El error que estás cometiendo
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-6 text-lg text-slate-300 font-sans leading-relaxed" data-id="element-197">
          <FadeIn delay={0.1} data-id="element-198">
            <p data-id="element-199">
              El error más común es creer que tu gato te despierta por hambre o
              por maldad. La realidad es que{' '}
              <strong className="text-gold font-semibold" data-id="element-200">
                su instinto de cazador está atrapado en un departamento de 40
                metros cuadrados.
              </strong>
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-201">
            <p data-id="element-202">
              Gritarle, tirarle un almohadón o encerrarlo en el baño solo
              empeora el problema. Para un gato, cualquier reacción tuya
              —incluso un grito— es un premio porque logró captar tu atención.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-203">
            <div className="bg-red-900/20 border border-red-500/20 rounded-xl p-6 mt-8 text-center" data-id="element-204">
              <p className="text-red-200 font-medium" data-id="element-205">
                Lo estás entrenando para que sea un extorsionador nocturno
                profesional sin darte cuenta.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}